import React from 'react';

import moment from 'moment-timezone';
import { Control, Controller, FieldArrayWithId, FieldErrors, UseFormSetValue } from 'react-hook-form';

import { IContract } from 'store/projectContract.store';

import { CheckboxComponent } from 'components/common/CheckboxComponent/CheckboxComponent';
import constants from 'components/common/Constants/constants';
import { CustomizedDatePicker } from 'components/common/CustomizedDatePicker/CustomizedDatePicker';
import TextSearchInput from 'components/common/TextSearchInput/textSearchInput';
import { Details } from 'components/common/UploadFileModal/components/programLibrary.types';
import classes from 'components/common/UploadFileModal/mainFilesListTable.module.scss';
import { CustomizedFormErrorMessage } from 'components/common/index';

type Props = {
    fields: FieldArrayWithId<Details, 'versions'>[];
    control: Control<Details>;
    setValue: UseFormSetValue<Details>;
    errors: FieldErrors<Details>;
    contract: IContract;
};

const PlaniswareTable = ({ fields, control, setValue, errors, contract }: Props) => {
    return (
        <div
            data-testid={'table-container'}
            className={`${classes.tableContainer} ${classes.plfTableContainer} ${classes.planisware}`}
        >
            <table className={classes.table}>
                <tbody>
                    <tr>
                        <th>Version</th>
                        <th>Date</th>
                        <th>Baseline / Re-baseline</th>
                    </tr>
                    {fields.map((row, index) => {
                        return (
                            <tr key={row.id}>
                                <td>
                                    <Controller
                                        render={({ field }) => (
                                            <TextSearchInput
                                                {...field}
                                                placeholder={''}
                                                isSearch={false}
                                                handleClear={() => {
                                                    setValue(`versions.${index}.versionName`, '');
                                                }}
                                            />
                                        )}
                                        name={`versions.${index}.versionName`}
                                        control={control}
                                        rules={{
                                            minLength: {
                                                value: 2,
                                                message: 'Version name is too short',
                                            },
                                        }}
                                    />
                                </td>
                                <td>
                                    <Controller
                                        render={({ field }) => (
                                            <CustomizedDatePicker
                                                value={moment(field.value).valueOf()}
                                                handleChange={(value) => {
                                                    setValue(
                                                        `versions.${index}.versionDate`,
                                                        moment(value).format(constants.formats.date.versionDate),
                                                    );
                                                    setValue(
                                                        `versions.${index}.versionName`,
                                                        `${contract?.title}-${moment(value).format(
                                                            constants.formats.date.dayMonthYear,
                                                        )}`,
                                                    );
                                                }}
                                                minDate={moment().subtract(20, 'year').valueOf()}
                                                maxDate={moment().valueOf()}
                                            />
                                        )}
                                        name={`versions.${index}.versionDate`}
                                        control={control}
                                    />
                                </td>
                                <td>
                                    <Controller
                                        render={({ field }) => <CheckboxComponent {...field} checked={field.value} />}
                                        name={`versions.${index}.isBaseline`}
                                        control={control}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                    <tr>
                        <td colSpan={3}>
                            {errors.versions && (
                                <CustomizedFormErrorMessage text={'version name should be at least 2 characters'} />
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default PlaniswareTable;
